import React from 'react';
import PlaylistList from './PlaylistList';

const PlaylistManager = () => {
    return <PlaylistList />;
};

export default PlaylistManager;